module.exports = __webpack_public_path__ + "static/img/5.ae847fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experiment9/5.jpg
// module id = aRWT
// module chunks = 0